import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import { formatDate } from '@/lib/format';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

/**
 * Identification tab — ID number, issued-on date, issued-by authority.
 * Fields match the legacy Update/TabComponents/Identification panel.
 */
export function EmployeeTabIdentification({ emp }: Props) {
  return (
    <Card flat>
      <CardBody>
        <InfoGrid
          items={[
            { label: 'ID number', value: emp.employee_idno },
            { label: 'Issued on', value: formatDate(emp.employee_idno_issued_on) },
            { label: 'Issued by', value: emp.employee_idno_issued_by, full: true },
          ]}
        />
      </CardBody>
    </Card>
  );
}
